import localeAntd from 'ant-design-vue/lib/locale-provider/es_ES'

const messages = {
  topBar: {
    issuesHistory: 'Historial de problemas',
    typeToSearch: 'Start typing to search...',
    actions: 'Acciones',
    status: 'Estado',
    profileMenu: {
      hello: 'Hola',
      billingPlan: 'Plan de facturación',
      role: 'Rol',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      editProfile: 'Editar perfil',
      logout: 'Cerrar sesión',
    },
  },
}

export default {
  locale: 'es-ES',
  localeAntd,
  messages,
}
